import styled from 'styled-components';

export const CircleCheckBoxStyled = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 8px; 
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  .icon {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .icon.visible {
    opacity: 1;
    transform: scale(1);
  }
`;
